import React, { useEffect, useState } from 'react';
import '../../Admin1/Pages/admin1.css';
import heloicon from '../../../safreeimg/superadminimg/heloicon.png';
import axios from 'axios';
import Loader from '../../../safreeimg/loader.gif';
import { useNavigate } from 'react-router-dom';
import leftarrow from '../../../safreeimg/left-arrow.png';

const AddNewSubGroup = () => {
  const [users, setUsers] = useState([]);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [selectedGuardians, setSelectedGuardians] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  
  const rowsPerPage = 10;
  const navigate = useNavigate();
  

  const groupId = window.location.hash.replace('#', '');  

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');

        if (!token) {
          setError('No authentication token found');
          setLoading(false);
          return;
        }

        const response = await axios.get(
          'https://api.safree.org/api-v2022/organization/auth/v1/organizationUsers',
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.success) {
          setUsers(response.data.data);
        } else {
          setError('Failed to fetch users');
        }
      } catch (err) {
        console.error('Error fetching users:', err);
        setError('An error occurred while fetching users: ' + err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const totalPages = Math.ceil(users.length / rowsPerPage);
  const currentRows = users.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handlePageChange = (direction) => {
    if (direction === 'prev' && currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
    if (direction === 'next' && currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const getPageNumbers = () => {
    const maxPageNumbersToShow = 5;
    const startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
    const endPage = Math.min(totalPages, startPage + maxPageNumbersToShow - 1);

    const pageNumbers = [];
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!name || !description) {
      setError('Please fill in all the fields.');
      return;
    }
  
    if (selectedMembers.length === 0 && selectedGuardians.length === 0) {
      setError('Please select at least one member or guardian.');
      return;
    }
  
    try {
      const token = localStorage.getItem('token');
  
      if (!token) {
        setError('No authentication token found');
        return;
      }
  
    
      const response = await axios.post(
        'https://api.safree.org/api-v2022/organization/auth/v1/createSubGroup',
        {
          name,
          description,
          members: selectedMembers,
          guardians: selectedGuardians,
          groupId: groupId,  
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
   
      console.log('Response:', response);
  
      if (response.data.success) {
        setName('');
        setDescription('');
        setSelectedMembers([]);
        setSelectedGuardians([]);
        setError(null);
        alert('Sub Group created successfully!');
      } else {
        setError('Failed to create group');
      }
    } catch (err) {
      console.error('Error creating group:', err);
      setError('An error occurred while creating the group: ' + err.message);
    }
  };

  const handleBackClick = () => {
    navigate(-1);  
  };

  const handleSelectAll = (type) => {
    if (type === 'members') {
      if (selectedMembers.length === users.length - selectedGuardians.length) {
        setSelectedMembers([]);  
        setSelectedMembers(users.filter(user => !selectedGuardians.includes(user.userId)).map(user => user.userId));  // Select all members excluding guardians
      }
    } else if (type === 'guardians') {
      if (selectedGuardians.length === users.length - selectedMembers.length) {
        setSelectedGuardians([]);  
      } else {
        setSelectedGuardians(users.filter(user => !selectedMembers.includes(user.userId)).map(user => user.userId));  // Select all guardians excluding members
      }
    }
  };


  const handleSelectUser = (userId, type) => {
    if (type === 'members') {
      setSelectedMembers(prevState =>
        prevState.includes(userId)
          ? prevState.filter(id => id !== userId)  
          : [...prevState, userId]  
      );
    } else if (type === 'guardians') {
      setSelectedGuardians(prevState =>
        prevState.includes(userId)
          ? prevState.filter(id => id !== userId)  
          : [...prevState, userId]  
      );
    }
  };

  if (loading) return <div className="loading"><img src={Loader} alt="" /></div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="container user-management">
      <div className="row header">
        <div className="col-md-12">
          <p className="sub-heading"><img onClick={handleBackClick} className="back-button" src={leftarrow} alt="" /> Add New Sub Group</p>
        </div>
      </div>

      <div className="row">
        <div className="col-md-4">
          <div className="form-container">
            <form className="styled-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Enter Sub Group Name</label>
                <input
                  type="text"
                  id="name"
                  className="form-control"
                  placeholder="Sub Group Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label htmlFor="description">Sub Group Description</label>
                <textarea
                  id="description"
                  className="form-control"
                  placeholder="Sub Group Description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                ></textarea>
              </div>
              <button type="submit" className="btn btn-submit">Create Group</button>
            </form>
          </div>
        </div>

        <div className="col-md-8">
          <div className="table-container tblmnual">
            <table className="styled-table">
              <thead>
                <tr>
                <th>
                    <input
                      type="checkbox"
                      checked={selectedMembers.length === users.length - selectedGuardians.length}
                      onChange={() => handleSelectAll('members')}
                    />
                  </th>
                <th>S. No</th>
                  <th>Name</th>
                  <th>Email</th>
                </tr>
              </thead>
              <tbody>
                {currentRows.map((user, index) => (
                  
                  <tr key={user.userId}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedMembers.includes(user.userId)}
                        onChange={() => handleSelectUser(user.userId, 'members')}
                        disabled={selectedGuardians.includes(user.userId)}
                      />
                    </td>
                    <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                    <td>{user.name}</td>
                    <td>{user.email}</td>
                    
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="pagination-container">
              <button
                className="pagination-btn"
                onClick={() => handlePageChange('prev')}
                disabled={currentPage === 1}
              >
                &laquo; Prev
              </button>
              {getPageNumbers().map((page) => (
                <button
                  key={page}
                  className={`pagination-btn ${currentPage === page ? 'active' : ''}`}
                  onClick={() => setCurrentPage(page)}
                >
                  {page}
                </button>
              ))}
              <button
                className="pagination-btn"
                onClick={() => handlePageChange('next')}
                disabled={currentPage === totalPages}
              >
                Next &raquo;
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddNewSubGroup;
